define('common/spinner',[
],
    function () {

        var spinnerShownAt = {};

        function show(spinnerSelector) {
            $(spinnerSelector).removeClass("d-none");
            var image = $(spinnerSelector).find("img");
            if (image.length) {
                var alt = $(image).attr("alt");
                if (!alt)
                    $(image).attr("alt", "Spinner");
            }
            // mark the time when this spinner was displayed
            spinnerShownAt[spinnerSelector] = Date.now();
        }

        function hide(spinnerSelector, callbackWhenHidden) {
            // This logic ensures that the spinner is displayed for at least 500ms.
            // Otherwise it just flickers and that doesn't look good for the user.
            var waitTime = 500 - (Date.now() - spinnerShownAt[spinnerSelector]);
            if (waitTime > 0) {
                setTimeout(function () {
                    $(spinnerSelector).addClass("d-none");
                    if (callbackWhenHidden) callbackWhenHidden();
                }, waitTime);
            }
            else {
                $(spinnerSelector).addClass("d-none");
                if (callbackWhenHidden) callbackWhenHidden();
            }
        }

        function getSpinnerHtml(spinnerId) {
            return '<div id="' + spinnerId + '" class="spinner-wrapper d-none"><div class="overlay"></div><div class="spinner"></div></div>';
        }

        return {
            show: show,
            hide: hide,
            getSpinnerHtml: getSpinnerHtml
        };
    });

